export const isDate = (date: string) => {
  return date.match(/^\d{4}-\d{2}-\d{2}$/) !== null;
};

export const today = new Date().toISOString().split("T")[0];

export const getDateString = (date: string) => {
  return new Date(date).toLocaleDateString("de");
};
